import React from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../context';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

function Sidebar() {
    const {t} = useTranslation();
    const { buttonEnter,initialSidebar, final, animation1, Leave ,isSidebarOpen, closeSidebar , openContact} = useGlobalContext();
    const contactController = () => {
        closeSidebar();
        openContact();
    }
  return (
    <motion.section
    animate={isSidebarOpen ? final : initialSidebar}
            transition={animation1}
    className={`${isSidebarOpen === true ? 'sidebar section':'sidebar__closed'}`}>
        <div className="container sidebar__container">
            <div className="navbar__container sidebar__header">
                <Link to="/" className='navbar__logo'><img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1691029863/logo-black_uykbxa.png" alt="DADY Consulting logo" /></Link>
                <button onMouseEnter={buttonEnter} onMouseLeave={Leave} className="hide-for-desktop navbar__open_sidebar" onClick={() => closeSidebar()}>
                    <div className="navbar__open_sidebar_line sidebar__close sidebar__close_line1"/>
                    <div className="navbar__open_sidebar_line sidebar__close sidebar__close_line2"/>
                </button>
            </div>
            <div className="sidebar__links_container">
                <div className="navbar__link_contaner"><Link to="#" className="sidebar__link">{t('nav.link1')}</Link></div>
                <div className="navbar__link_contaner"><Link to="#" className="sidebar__link">{t('nav.link2')}</Link></div>
                <div className="navbar__link_contaner"><Link to="#" className="sidebar__link">{t('nav.link3')}</Link></div>
                <div className="navbar__link_contaner"><Link to="#" className="sidebar__link" onClick={() => contactController()}>{t('nav.contact')}</Link></div>
                <div className="navbar__link_contaner"><Link to="#" className="sidebar__link sidebar__language">{t('nav.language')}</Link></div>
            </div>
            <div className="sidebar__footer">
                <div className="footer__logo_container">
                    <Link to="/" className='navbar__logo'><img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1690355560/logo-white_ziqt3y.png" alt="DADY Consulting logo" /></Link>
                </div>
                <div className="footer__contact_container deleted">
                    <p className='white'>+125 36578 2025</p>
                    <p className='white'>Contact@dadyconsulting.fr</p>
                    <p className='white'>12 Rue Mohamed, Paris</p>
                </div>
                <div className="footer__contact_container">
                    <p className='white adress'>12 Rue Mohamed, Paris</p>
                </div>
                <div className="footer__social_container sidebar__social_container">
                    <Link to='#' className='sidebar__social_link'>FACEBOOK</Link>
                    <Link to='#' className='sidebar__social_link'>TWITTER</Link>
                    <Link to='#' className='sidebar__social_link'>INSTAGRAM</Link>
                    <Link to='#' className='sidebar__social_link'>LINKEDIN</Link>
                </div>
            </div>     
        </div>
    </motion.section>
  )
}

export default Sidebar;